import { i18n } from "@/locales/settings";
import { LocalesFields } from "@/locales/translateInterface";

export default {
  namespaced: true,
  state: {
    forms: [],
    backendErrors: []
  },
  actions: {
    CHECK_BACKEND(ctx: any, errors: any) {
      ctx.commit("ADD_BACKEND_ERRORS", errors);
      setTimeout(() => {
        let els = document.querySelector(`.invalid`);

        if (els) {
          ctx.dispatch(
            "localError",
            i18n.tc(LocalesFields.SorrySomethingWentWrong),
            {
              root: true
            }
          );

          if (els) {
            els?.scrollIntoView({
              block: "center",
              inline: "nearest",
              behavior: "smooth"
            });
          }
        }
      }, 500);
    },
    async CHECK_VALIDATIONS(ctx: any, key: string = "default") {
      await ctx.commit("TRIGGER_VALIDATE_FORM", key);
      let els = document.querySelector(`.invalid[data-valid="${key}"]`);
      if (els) {
        ctx.dispatch(
          "localError",
          i18n.tc(LocalesFields.SorrySomethingWentWrong),
          {
            root: true
          }
        );
        if (els) {
          els?.scrollIntoView({
            block: "center",
            inline: "nearest",
            behavior: "smooth"
          });
        }
        return true;
      }
      return false;
    }
  },
  mutations: {
    ADD_VALIDATE_FORM(state: any, key: string) {
      !state.forms?.find((el: any) => el.key === key)
        ? state.forms.push({ key: key, trigger: 0 })
        : null;
    },
    ADD_BACKEND_ERRORS(state: any, errors: any) {
      state.backendErrors = errors;
    },
    TRIGGER_VALIDATE_FORM(state: any, key: string) {
      let el;
      el = state?.forms.find((el: any) => el.key === key);
      el.trigger++;
    },
    CLEAR_VALIDATION_FORMS(state: any) {
      state.forms = [];
      state.backendErrors = [];
    }
  },
  getters: {
    GET_FORM: (state: any) => (key: string) => {
      return state.forms.find((form: any) => form.key === key);
    },
    GET_BACKEND_ERROR: (state: any) => (error: string) => {
      return state.backendErrors.find((err: any) => err.propertyPath === error);
    }
  }
};
